/* eslint-disable import/no-anonymous-default-export */

export default {
  cores: {
    agendamento: '#8f33f8',
    pendente: '#F87433',
    informacao: '#007bff',
    unitech: '#13293d',
    login: '#2f6fed',
    entrega: '#4caf50',
    andamento: '#247BA0',
    edicao: '#e87f00',
    lightGray2: '#F5F5F8',
    linha: '#DDDDDD',
    white: '#ffffff',
    black: '#000000',
    money: '#ff6c42',
    red: '#FF0000'
  },
  fontes: {
    extraExtraGrande: '30px',
    extraGrande: '24px',
    grande: '20px',
    normal: '16px',
    media: '14px',
    pequena: '12px',
    extraPequena: '10px',
  },
};
